const EMPTY_ARRAY = [] as [];

export const safeEmptyArray = <T>(value: T[] | null | undefined): T[] => {
  if (!Array.isArray(value) || !value.length) {
    return EMPTY_ARRAY as T[];
  }
  return value;
};
